import { render, staticRenderFns } from "./PopupBlock.vue?vue&type=template&id=79090929&scoped=true&"
import script from "./PopupBlock.vue?vue&type=script&lang=js&"
export * from "./PopupBlock.vue?vue&type=script&lang=js&"
import style0 from "./PopupBlock.vue?vue&type=style&index=0&id=79090929&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79090929",
  null
  
)

export default component.exports